<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .btn.btn-segment {
    @include salesflow-text($color: $salesflow-font-gray);

    i {
      font-size: 18px
    }
  }

  .save-segment a {
    @include salesflow-text($color: $salesflow-font-gray, $font-weight: 500);
  }
</style>

<template>
  <div class="save-segment mr-3">
    <a
      href="#"
      @click="open()"
      v-if="filters"
    ><i class="fa fa-code-fork mr-1" /> {{ __('Salvar filtro como segmentação...') }}</a>
    <BModal
      id="modal-lead-segment"
      modal-class="modal-width-420"
      ref="modal-lead-segment"
      hide-footer="hide-footer"
    >
      <template slot="modal-title">
        {{ __('Salvar filtro como segmentação') }}
      </template>
      <template slot="default">
        <form @submit.prevent="save()">
          <p>{{ __('Salve este filtro como segmentação para ter fácil acesso a ele posteriormente.') }}</p>
          <p>{{ __('Segmentações também podem ser utilizadas como regra de uma determinada automação.') }}</p>
          <div class="form-group">
            <label>{{ __('Nome') }}</label>
            <input
              class="form-control"
              v-model="name"
              placeholder="Nome da segmentação"
            >
            <label class="mt-3">
              <input
                type="checkbox"
                v-model="private"
              > {{ __('Segmentação privada') }}
            </label>
            <div class="col-12 text-center mt-3">
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="disabled"
              >
                <span v-if="saving"><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Salvando') }}</span><span v-else>{{ __('Salvar') }}</span>
              </button>
            </div>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['filters'],

  data () {
    return {
      name: '',
      loading: false,
      saving: false,
      private: null,
    };
  },

  computed: {
    disabled () {
      return this.name === '' || this.saving;
    },
  },

  methods: {
    open () {
      this.$refs['modal-lead-segment'].show();
    },

    save () {
      this.saving = true;

      this.$http.post('/lead/segment', {
        name: this.name,
        context: this.filters,
        private: this.private,
      })
        .then((response) => {
          Alert.info(this.__('Segmentação criada!'));

          this.$refs['modal-lead-segment'].hide();

          window.location.href = `${window.location.href}&segment=${response.data.id}`;
        })
        .catch((response) => {
          if (response?.status === 422 && response?.data?.message) {
            return Alert.error(response.data.message);
          }

          return Alert.error(this.__('Ocorreu um erro inesperado ao salvar filtros como segmentação'));
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
